import { render, staticRenderFns } from "./RepairtaskDetail.vue?vue&type=template&id=b4f97654&scoped=true&"
import script from "./RepairtaskDetail.vue?vue&type=script&lang=js&"
export * from "./RepairtaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./RepairtaskDetail.vue?vue&type=style&index=0&id=b4f97654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f97654",
  null
  
)

export default component.exports